// extracted by mini-css-extract-plugin
export var box = "_61-0";
export var check = "_61-1";
export var checkboxButton = "_61-6";
export var checkboxGroup = "_61-5";
export var disabled = "_61-7";
export var ghost = "_61-9";
export var input = "_61-2";
export var label = "_61-4";
export var normal = "_61-8";
export var uncheck = "_61-3";